import { createSelector } from 'reselect';
import moment from 'moment-timezone';

const sessionsSelector = state => state.subscription.sessions;

export const selectNewSessions = createSelector(
  sessionsSelector,
  sessions =>
    sessions.get('data')
      ? sessions
          .get('data')
          .filter(session => session.get('status') === 'submitted')
          .toJS()
      : null
);

export const selectBookedSessions = createSelector(
  sessionsSelector,
  sessions =>
    sessions.get('data')
      ? sessions
          .get('data')
          .filter(session => {
            return (
              session.get('status') === 'accepted' &&
              moment(session.get('accepted_session_date'))
                .tz(session.get('time_zone_id'))
                .isAfter()
            );
          })
          .toJS()
      : null
);

export const selectCompletedSessions = createSelector(
  sessionsSelector,
  sessions =>
    sessions.get('data')
      ? sessions
          .get('data')
          .filter(session => {
            return (
              session.get('status') === 'accepted' &&
              moment(session.get('accepted_session_date'))
                .tz(session.get('time_zone_id'))
                .isBefore()
            );
          })
          .sort((a, b) => (a.get('accepted_session_date') >= b.get('accepted_session_date') ? -1 : 1))
          .toJS()
      : null
);



// WEBPACK FOOTER //
// ./src/subscription/sessions/redux/selectors.js